export default __webpack_public_path__ + "static/media/projectFolder.1a2e8498.svg";